import { Text } from "@otrium/atoms";
import styled from "@emotion/styled";

const RangeText = styled(Text)`
  width: auto;
  display: inline-table;
  white-space: nowrap;
`;

export { RangeText };
